export const userAuthenticatedMiddleware = next => () => ctx => next(Object.assign(Object.assign({}, ctx), { auth: Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.username) }));
//# sourceMappingURL=user-authenticated.js.map